import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'
import { Token } from './login'

export const PlanoDiferenciadoSchema = z.object({
    limiteFuncionarios:
        zod.PlanoDiferenciadoSchema.shape.limiteFuncionarios.optional(),
    periodicidade: zod.PlanoDiferenciadoSchema.shape.periodicidade.optional(),
    valorCentavos: zod.PlanoDiferenciadoSchema.shape.valorCentavos.optional(),
})

export const CreatePlanoDiferenciadoSchema =
    PlanoDiferenciadoSchema.optional().transform(data => {
        if (!data) return data

        if (
            !data.limiteFuncionarios ||
            !data.periodicidade ||
            !data.valorCentavos
        )
            return undefined

        return data
    })

export const AvaliacaoSchema = zod.AvaliacaoSchema.pick({
    nomeResponsavel: true,
    telefone: true,
}).extend({
    senha: z.coerce
        .string()
        .trim()
        .min(6, 'A senha deve ter no mínimo 6 caracteres'),
    confirme: z.coerce.string().trim(),
    nomeFantasia: z
        .string()
        .trim()
        .min(1, 'O nome da empresa não pode ser vazio'),
    emailResponsavel: z.string().trim().email('Email inválido'),
    nomeResponsavel: z
        .string()
        .trim()
        .min(3, 'O nome do responsável precisa de ao menos 3 caracteres'),
    funcaoId: z.number().min(1, 'A função precisa ser selecionada'),
    limiteFuncionarios: z
        .number()
        .min(1, 'A faixa de colaboradores precisa ser selecionada'),
    categoriaId: z.number().default(6),
    criadorId: z.number().nullish(),
    PlanoDiferenciado: CreatePlanoDiferenciadoSchema,
})

export const CreateAvaliacaoSchema = AvaliacaoSchema.refine(
    data => data.senha === data.confirme,
    {
        message: 'As senhas não conferem',
        path: ['confirme'],
    },
)

export type CreateAvaliacaoInput = z.infer<typeof CreateAvaliacaoSchema>

export type Avaliacao = z.infer<typeof zod.AvaliacaoSchema> & { Token?: Token }

export const avaliacao = new ApiService<CreateAvaliacaoInput, Avaliacao>(
    'avaliacao',
)
